




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getCookie } from "@szgc/plt-core-v2";
import request from "../../api/request";
import Api from "../../api/index";

@Component({
  name: "UrgerSelect"
})
export default class UrgerSelect extends Vue {
  @Prop({
    type: [String, Number],
    default: ""
  })
  private businessId!: any;

  private prefix: string = "";
  private urgers: { childMatterUrgers: any[]; curMatterUrgers: any[] } = {
    childMatterUrgers: [],
    curMatterUrgers: []
  }; // 催办人

  @Watch("businessId", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.getUrgers();
    }
  }

  /* 获取催办人 */
  async getUrgers() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.urgers(this.businessId),
        method: "get"
      });
      if (!success) {
        this.$message.error(`获取催办人失败:${message}`);
        return false;
      }
      this.urgers = {
        childMatterUrgers: data && data.childMatterUrgers ? data.childMatterUrgers : [],
        curMatterUrgers: data && data.curMatterUrgers ? data.curMatterUrgers : []
      };
    } catch (error) {
      this.$message.error(`获取催办人失败:${error}`);
    }
  }

  /* 确定 */
  submit() {
    const tempChildUrgers: any = (this.$refs.childUrgerTable as any).selection;
    const tempCurUrgers: any = (this.$refs.curUrgerTable as any).selection;
    const childMatterUrgers: any[] = [],
      curMatterUrgers: any[] = [];
    if (tempChildUrgers && tempChildUrgers.length) {
      tempChildUrgers.forEach((item: any) => {
        childMatterUrgers.push(item.userId);
      });
    }
    if (tempCurUrgers && tempCurUrgers.length) {
      tempCurUrgers.forEach((item: any) => {
        curMatterUrgers.push(item.userId);
      });
    }
    this.$emit("submit", {
      childMatterUrgers: childMatterUrgers,
      curMatterUrgers: curMatterUrgers
    });
  }

  /* 取消 */
  cancel() {
    this.$emit("cancel");
  }
}
